import { BaseApi, ResponseEntity } from "@/utils/request";

export class HomeApi extends BaseApi {
  constructor() {
    super();
  }
  
  /**
   * Banner
   */
  public getBanners(): Promise<ResponseEntity> {
    return this.get("/Home/GetBanners");
  }
  
  /**
   * 时文
   */
  public getOptions(): Promise<ResponseEntity> {
    return this.get("/Home/getOptions");
  }
  
  /**
   * 图文
   */
  public getImgTexts(): Promise<ResponseEntity> {
    return this.get("/Home/GetImgTexts");
  }
  
  /**
   * 视频
   */
  public getVideos(): Promise<ResponseEntity> {
    return this.get("/Home/GetVideos");
  }
}
